import React, { useEffect, useState } from "react";

const SettingsForm = (props) => {
  const [check, setCheck] = useState();
  useEffect(() => {
    if (props.data) setCheck(props.data.prepa);
  }, [props.data]);
  return (
    <div className="card card-custom">
      {/*begin::Form*/}

      <form onSubmit={props.handleSubmit(props.onSubmit)}>
        <div className="card-body">
          <div className="form-group">
            <label>
              - Afficehr les Carnets pour les parents?{" "}
              <span className="text-danger"> </span>
            </label>
            <input
              ref={props.register}
              name="showCard"
              type="checkBox"
              className="form-group"
              style={{ width: 20, height: 20, marginLeft: 40 }}
              onChange={(e) => setCheck(e.target.checked)}
              defaultChecked={props.data?.showCard}
            />
          </div>
        </div>
        <div className="card-footer">
          <button type="submit" className="btn btn-primary mr-2">
            Valider
          </button>
        </div>
      </form>

      {/*end::Form*/}
    </div>
  );
};

export default SettingsForm;
